import {ReactNode, useCallback, useEffect, useMemo, useRef} from "react";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {openLeadModal, setUseAdditionalFormField} from "../../lead/state/lead_modal_slice";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {ILeadModalOpenPayload} from "../../lead/types/ILeadModalOpenPayload";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {gtmEventFormOpen, IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";

export interface IApplicationModalButtonRenderProps {
    isOpened: boolean;
    openModal: (gtmProps: {
        clickText: InquiryButtonTypeName | string;
        source: GTMEventApplicationSourceSection | string;
        vendorName: string;
        offerName: string;
    }) => void;
}

type IProps = {
    render: (props: IApplicationModalButtonRenderProps) => ReactNode;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<ILeadModalOpenPayload, "gtmMeta">;

export const ApplicationModalButton = (props: IProps) => {
    const {render, openOnMount, onOpen, onClose, ...openModalPayload} = props;
    const dispatch = useAppDispatch();

    const isOpened = useAppSelector((state) => state.leadModal.isModalOpen);
    const wasOpenedRef = useRef(false);

    const handleOpenModal = (openButtonSource: string, openButtonSourceText: string) => {
        if (openModalPayload.useAdditionalFormField) {
            dispatch(setUseAdditionalFormField(openModalPayload.useAdditionalFormField));
        }

        dispatch(
            openLeadModal({
                ...openModalPayload,
                gtmMeta: {
                    openButtonSource,
                    openButtonSourceText
                }
            })
        );
    };

    const openModal = useCallback((gtmProps?: IGTMEventLeadForm) => {
        if (gtmProps) {
            gtmEventFormOpen(gtmProps.clickText, gtmProps.source, gtmProps.vendorName, gtmProps.offerName);
            handleOpenModal(gtmProps.clickText, gtmProps.source);
        }
    }, []);

    useEffect(() => {
        if (openOnMount) {
            openModal();
        }
    }, []);

    useEffect(() => {
        const wasOpened = Boolean(wasOpenedRef.current);
        if (!wasOpened && isOpened) {
            onOpen?.();
        }

        if (wasOpened && !isOpened) {
            onClose?.();
        }

        wasOpenedRef.current = isOpened;
    }, [isOpened]);

    const renderProps = useMemo(() => ({isOpened, openModal}), [isOpened, openModal]);

    return <>{render(renderProps)}</>;
};
import {ReactNode, useCallback, useEffect, useMemo, useRef} from "react";

import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {openLeadModal, setUseAdditionalFormField} from "../../lead/state/lead_modal_slice";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {ILeadModalOpenPayload} from "../../lead/types/ILeadModalOpenPayload";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {gtmEventFormOpen, IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";

export interface IApplicationModalButtonRenderProps {
    isOpened: boolean;
    openModal: (gtmProps: {
        clickText: InquiryButtonTypeName | string;
        source: GTMEventApplicationSourceSection | string;
        vendorName: string;
        offerName: string;
    }) => void;
}

type IProps = {
    render: (props: IApplicationModalButtonRenderProps) => ReactNode;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<ILeadModalOpenPayload, "gtmMeta">;

export const ApplicationModalButton = (props: IProps) => {
    const {render, openOnMount, onOpen, onClose, ...openModalPayload} = props;
    const dispatch = useAppDispatch();

    const isOpened = useAppSelector((state) => state.leadModal.isModalOpen);
    const wasOpenedRef = useRef(false);

    const handleOpenModal = (openButtonSource: string, openButtonSourceText: string) => {
        if (openModalPayload.useAdditionalFormField) {
            dispatch(setUseAdditionalFormField(openModalPayload.useAdditionalFormField));
        }

        dispatch(
            openLeadModal({
                ...openModalPayload,
                gtmMeta: {
                    openButtonSource,
                    openButtonSourceText
                }
            })
        );
    };

    const openModal = useCallback((gtmProps?: IGTMEventLeadForm) => {
        if (gtmProps) {
            gtmEventFormOpen(gtmProps.clickText, gtmProps.source, gtmProps.vendorName, gtmProps.offerName);
            handleOpenModal(gtmProps.clickText, gtmProps.source);
        }
    }, []);

    useEffect(() => {
        if (openOnMount) {
            openModal();
        }
    }, []);

    useEffect(() => {
        const wasOpened = Boolean(wasOpenedRef.current);
        if (!wasOpened && isOpened) {
            onOpen?.();
        }

        if (wasOpened && !isOpened) {
            onClose?.();
        }

        wasOpenedRef.current = isOpened;
    }, [isOpened]);

    const renderProps = useMemo(() => ({isOpened, openModal}), [isOpened, openModal]);

    return <>{render(renderProps)}</>;
};
